import { render, staticRenderFns } from "./NftAssetCard.vue?vue&type=template&id=2d2cabd1&scoped=true"
import script from "./NftAssetCard.vue?vue&type=script&lang=ts"
export * from "./NftAssetCard.vue?vue&type=script&lang=ts"
import style0 from "./NftAssetCard.vue?vue&type=style&index=0&id=2d2cabd1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2cabd1",
  null
  
)

export default component.exports